// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"655":"4ee2eeaf","2067":"6fb0c475"}[chunkId] + ".chunk.css";
};